import React from 'react'

const Home = () =>{

  function closeMenu() {

    document.getElementById('menu-btn').checked=false;

    let anchorSelector = 'a[href^="#"]';

    let anchorList = document.querySelectorAll(anchorSelector);

    anchorList.forEach(link => {
      link.onclick = function () {
        let destination = document.querySelector(this.hash);

        destination.scrollIntoView({
            behavior: 'smooth'
        });
        }
        
    });


  }

  return(
      //this is the first section a user interacts with
      <section className='Home' id="home">
      <div className="container" class="px-10 py-7">
        <header className="header" class="header">
          <input className="menu-btn" type="checkbox" id="menu-btn"/>
          <label className="menu-icon" id="menu-icon" for="menu-btn"><span class="navicon"></span></label>
          <ul className="menu" >
            <li><a href="#home" onClick={closeMenu} class="anchor">Home</a></li>
            <li><a href="#about" onClick={closeMenu} class="anchor">About</a></li>
            <li><a href="#services" onClick={closeMenu} class="anchor">Services</a></li>
            <li><a href="#contact" onClick={closeMenu} class="anchor">Contact</a></li>
          </ul>
        </header>
        <div className='words' class="mt-48" id="words">
          <h1 class="text-5xl text-white max-md:text-4xl">KIRCHE CONSULTANTS</h1>
          <p class="text-white text-base leading-10 text-justify mt-10 w-1/2 max-[940px]:w-3/4 max-sm:w-full">We are a civil engineering consulting firm that 
            carries out designs for buildings, dams, water and sewerage systems, 
            and roads. Consult with us today!</p>
          <button class="px-5 py-3 text-center text-white font-semibold mt-10 drop-shadow-2xl"><a href="#contact">CONTACT US</a></button>
        </div>
      </div>
    </section>
  )
}

export default Home